import { Box, Stack } from "@mui/material";

import Blocks from "../components/Blocks";
import Header from "../components/Header";

const MainPage = () => {
  return (
    <Stack maxWidth={"440px"} position={"relative"}>
      <Header />
      <Box height={"100dvh"} overflow={"auto"}>
        <Blocks />
      </Box>
    </Stack>
  );
};

export default MainPage;
